import { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Accordion from "react-bootstrap/Accordion";
import { TiDeleteOutline } from "react-icons/ti";
import { FcPlus, FcList } from "react-icons/fc";
import { TiEdit } from "react-icons/ti";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Container, Row, Col, Button, Form, Stack } from 'react-bootstrap';
import Modal from "react-bootstrap/Modal";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import { useAuthContext } from "../../contexts/AuthContext";
import { countryList, dataBaseTypes, masterKeyDataTypes, columnIndexList, columnConditionList } from '../../constant/index';
import ProjectDataService from "../../services/project.service";
import FormInputText from "../../components/FormField/FormInput";
import FormSelect from "../../components/FormField/FormSelect";
import "./Project.scss";


function ProjectCreate() {

  let { projectId } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const { setIsLoading } = useAuthContext();

  const [project, setProject] = useState();
  const [projectName, setProjectName] = useState("");
  const [country, setCountry] = useState("");
  const [assetCode, setAssetCode] = useState("");
  const [isIntermeditaryDataDatabase, setIsIntermeditaryDataDatabase] = useState(false);
  const [databaseType, setDatabaseType] = useState("");
  const [fileFormat, setFileFormat] = useState("");
  const [serverPath, setServerPath] = useState("");
  const [serverUserName, setServerUserName] = useState("");
  const [serverPassword, setServerPassword] = useState("");
  const [serverPortNumber, setServerPortNumber] = useState("");
  const [serverFolderPath, setServerFolderPath] = useState("");
  const [localStoreData, setLocalStoreData] = useState("");
  const [productFieldKeys, setProductFieldKeys] = useState("");
  const [sasFieldKeys, setSasFieldKeys] = useState("");
  const [isDataDatabase, setIsDataDatabase] = useState(false);
  const [isDataApi, setIsDataApi] = useState(false);
  const [dbHostURL, setDbHostURL] = useState("");
  const [dbPort, setDbPort] = useState("");
  const [dbUserName, setDbUserName] = useState("");
  const [dbPassword, setDbPassword] = useState("");
  const [dbName, setDbName] = useState("");
  const [indatabaseType, setInDatabaseType] = useState("");
  const [indbHostURL, setInDbHostURL] = useState("");
  const [indbPort, setInDbPort] = useState("");
  const [indbUserName, setInDbUserName] = useState("");
  const [indbPassword, setInDbPassword] = useState("");
  const [indbName, setInDbName] = useState("");
  const [masterFiles, setMasterFiles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [masterKeyName, setMasterKeyName] = useState("");
  const [masterTableName, setMasterTableName] = useState("");
  const [isMaster, setIsMaster] = useState(false);
  const [insertOrder, setInsertOrder] = useState(1);
  const [hasAssociatedTable, setHasAssociatedTable] = useState(false);
  const [masterFieldKeys, setMasterFieldKeys] = useState([]);
  const [selectedMaster, setSelectedMaster] = useState();
  const [masterKeyRecordType, setMasterKeyRecordType] = useState({ value: "", isValid: false });
  const [masterKeyFieldName, setMasterKeyFieldName] = useState({ value: "", isValid: false });
  const [masterKeyDataType, setMasterKeyDataType] = useState({ value: "", isValid: false });

  const [masterKeyMetaDataFieldName, setMasterKeyMetaDataFieldName] = useState({ value: "", isValid: false });
  const [masterKeyMetaDataType, setasterKeyMetaDataType] = useState({ value: "", isValid: false });
  const [masterMetaDataFieldKeys, setMasterMetaDataFieldKeys] = useState([]);

  const [metaDataFieldName, setMetaDataFieldName] = useState();
  const [metaDataFieldValue, setMetaDataFieldValue] = useState();

  const [masterKeyFieldSubmit, setMasterKeyFieldSubmit] = useState(false);
  const [masterKeys, setMasterKey] = useState();
  const [metadata, setMetadata] = useState([]);
  const [showMetadata, setShowMetadata] = useState(false);
  
  const [showDefaultColumns, setShowDefaultColumns] = useState(false);
  const [defaultColumns, setDefaultColumns] = useState([]);
  const [defaultColumnsFieldName, setDefaultColumnsFieldName] = useState({ value: "", isValid: false });
  const [defaultColumnsDataType, setDefaultColumnsDataType] = useState({ value: "", isValid: false });
  


  const isEdit = (projectId && location && location.pathname && location.pathname.includes('/edit')) ? true : false;
  const isView = (projectId && location && location.pathname && !location.pathname.includes('/edit')) ? true : false;
  const isCreate = (!projectId) ? true : false;

  useEffect(() => {
    console.log('projectId', projectId);
    retrieveProjectDetails(projectId);
  }, [projectId]);

  useEffect(() => {
    if(project){
      setProjectName(project.projectName);
      setCountry(project.country);
      setAssetCode(project.assetCode);
      setDatabaseType(project.databaseType);
      setDbHostURL(project.dbHostURL);
      setDbPort(project.dbPort);
      setDbUserName(project.dbUserName);
      setDbPassword(project.dbPassword);
      setDbName(project.dbName);
      setServerPath(project.serverPath);
      setServerUserName(project.serverUserName);
      setServerPassword(project.serverPassword);
      setServerPortNumber(project.serverPortNumber);
      setServerFolderPath(project.serverFolderPath);
      setMasterKey(project.masterKeys);
      setMasterFiles(project.masterKeys);
      setInDatabaseType(project.indatabaseType);
      setInDbHostURL(project.indbHostURL);
      setInDbPort(project.indbPort);
      setInDbUserName(project.indbUserName);
      setInDbPassword(project.indbPassword);
      setInDbName(project.indbName);
      setDefaultColumns(project.defaultColumns);
      setInsertOrder(project.insertOrder);
    }
  }, [project]);

  function retrieveProjectDetails(projectId) {
    setIsLoading(true);
    ProjectDataService.get(projectId).then((response) => {
      setIsLoading(false);
      setProject(response.data.data);
    });
  }


  const createEditProject = () => {
    
    var data = {
      projectName,
      country,
      assetCode,
      databaseType,
      dbHostURL,
      dbPort,
      dbUserName,
      dbPassword,
      dbName,
      serverPath,
      serverUserName,
      serverPassword,
      serverPortNumber,
      serverFolderPath,
      masterKeys: masterFiles,
      indatabaseType,
      indbHostURL,
      indbPort,
      indbUserName,
      indbPassword,
      indbName,
      defaultColumns,
      insertOrder
    };

    if(isEdit){
      setIsLoading(true);
      ProjectDataService.update(projectId, data).then(() => {
        setIsLoading(false);
        console.log('data', data);
        toast.success("Project Updated!");
        navigate("/projects/" + projectId);
      });
    } else if(isCreate){
      setIsLoading(true);
      ProjectDataService.create(data).then(() => {
        setIsLoading(false);
        console.log('data', data);
        toast.success("Project Created!");
        navigate("/projects/" + projectId);
      });
    }

    
  };

  const handleEditFieldForm = (id) =>{

   setShowModal(true);
   
   var filterMasterArray = masterKeys.filter(function (item) {
     if(item._id === id){
      return item.masterKeyFields;
     }
   });

   console.log('handleEditFieldForm', filterMasterArray);

   let editObject = filterMasterArray[0];

   setMasterKeyName(editObject.masterKeyName);
   setMasterTableName(editObject.masterTableName);
   setMasterFieldKeys(editObject.masterKeyFields);
   setIsMaster(editObject.isMaster);
   setInsertOrder(editObject.insertOrder);
   setSelectedMaster(editObject);

  } 

  const deleteMasterKeyFieldName = (fieldName) => {
    var data = masterFieldKeys.filter(function (item) {
      return item.fieldName !== fieldName;
    });
    setMasterFieldKeys(data);
  }

  const deleteMasterMetaDataKeyFieldName = (fieldName) => {
    var data = masterMetaDataFieldKeys.filter(function (item) {
      return item.fieldName !== fieldName;
    });
    setMasterMetaDataFieldKeys(data);
  }

  const createMasterFile = () => {
    let mstrFileObj = {};
    let filterMasterArray = [...masterFiles];
    mstrFileObj.masterKeyName = masterKeyName;
    mstrFileObj.isMaster = isMaster;
    mstrFileObj.insertOrder = insertOrder;
    mstrFileObj.condtionColIndex = '';
    mstrFileObj.condtionCol = '';
    mstrFileObj.condtionColValue = '';
    mstrFileObj.masterTableName = masterTableName;
    mstrFileObj.masterKeyFields = masterFieldKeys;
    mstrFileObj.masterKeyMetaDataFields = masterMetaDataFieldKeys;

    if(selectedMaster && selectedMaster._id){
      console.log('selectedMaster._id', selectedMaster._id);
      mstrFileObj = {...selectedMaster};
      mstrFileObj.masterKeyName = masterKeyName;
      mstrFileObj.isMaster = isMaster;
      mstrFileObj.insertOrder = insertOrder;
      mstrFileObj.masterTableName = masterTableName;
      mstrFileObj.masterKeyFields = masterFieldKeys;
      mstrFileObj.condtionColIndex = '';
      mstrFileObj.condtionCol = '';
      mstrFileObj.condtionColValue = '';
      mstrFileObj.masterKeyMetaDataFields = masterMetaDataFieldKeys;
      filterMasterArray = masterFiles.filter((item) => item._id !== mstrFileObj._id );
    }

    //console.log('filterMasterArray', filterMasterArray);
    console.log('mstrFileObj', mstrFileObj);
    setMasterFiles([...filterMasterArray, mstrFileObj]);
    setMasterKeyName("");
    setMasterTableName("");
    setInsertOrder("");
    setMasterFieldKeys([]);
    setSelectedMaster({});
    setShowModal(!showModal);
  }

  const onChangeMasterKeyFieldName = (value) => {
    let isValid = value ? true : false;
    setMasterKeyFieldName({
        ...masterKeyFieldName,
        value: value,
        isValid: isValid,
    });
  }

  const onChangeMasterKeyDataType = (value) => {
    let isValid = value ? true : false;
    setMasterKeyDataType({
      ...masterKeyDataType,
      value: value,
      isValid: isValid,
    });
  }

  const onChangeMasterKeyMetadataFieldName = (value) => {
    let isValid = value ? true : false;
    setMasterKeyMetaDataFieldName({
        ...masterKeyMetaDataFieldName,
        value: value,
        isValid: isValid,
    });
  }

  const onChangeMasterKeyMetaDataType = (value) => {
    let isValid = value ? true : false;
    setasterKeyMetaDataType({
      ...masterKeyMetaDataType,
      value: value,
      isValid: isValid,
    });
  }


  const onChangeDefaultColumnsFieldName = (value) => {
    let isValid = value ? true : false;
    setDefaultColumnsFieldName({
        ...defaultColumnsFieldName,
        value: value,
        isValid: isValid,
    });
  }

  const onChangeDefaultColumnsDataType = (value) => {
    let isValid = value ? true : false;
    setDefaultColumnsDataType({
      ...defaultColumnsDataType,
      value: value,
      isValid: isValid,
    });
  }

  // const onChangeMasterKeyRecordType = (value) => {
  //   let isValid = value ? true : false;
  //   setMasterKeyRecordType({
  //     ...masterKeyDataType,
  //     value: value,
  //     isValid: isValid,
  //   });
  // }

  

  const handleAddMasterMetaDataFieldKeys = () => {

    if (masterKeyMetaDataFieldName.isValid && masterKeyMetaDataType.isValid) {
      var tableColumn = {};
      //tableColumn.recordType = masterKeyRecordType.value;
      tableColumn.fieldName = masterKeyMetaDataFieldName.value;
      tableColumn.dataType = masterKeyMetaDataType.value;
      // tableColumn.isRequired = isRequired;
      // tableColumn.isPrimaryKey = isPrimaryKey;
      setMasterKeyMetaDataFieldName({
        value: "",
        isValid: false,
      });
      console.log('tableColumn', tableColumn);
      setMasterMetaDataFieldKeys([...masterMetaDataFieldKeys, tableColumn]);
    }
  }

  const handleAddMasterFieldKeys = () => {

    setMasterKeyFieldSubmit(true);

    if (masterKeyFieldName.isValid && masterKeyDataType.isValid) {
      var tableColumn = {};
      //tableColumn.recordType = masterKeyRecordType.value;
      tableColumn.fieldName = masterKeyFieldName.value;
      tableColumn.dataType = masterKeyDataType.value;
      // tableColumn.isRequired = isRequired;
      // tableColumn.isPrimaryKey = isPrimaryKey;
      setMasterKeyFieldName({
        value: "",
        isValid: false,
      });
      setMasterKeyFieldSubmit(false);
      console.log('tableColumn', tableColumn);
      setMasterFieldKeys([...masterFieldKeys, tableColumn]);
    }
  }


  const onChangeMMetadataFieldValue = (value, name) => {
    let updatedMetadata = metadata.filter(function (item) {
      if(item.metadataName === name){
       return item;
      }
    });
    updatedMetadata[0].metadataValue = value;

    setMetadata([...metadata], updatedMetadata);
  }

  const addMetaData = () => {
    setShowMetadata(!showMetadata);
  }

  const addDefaultColumns = () => {
    setShowDefaultColumns(!showDefaultColumns);
  }

  const handleAddMetaData = () => {
    let metadataArray = metadata.length > 0 ? [...metadata] : [];
    metadataArray.push({
        metadataName: metaDataFieldName,
        metadataValue: metaDataFieldValue
    });
    setMetadata(metadataArray);
    setMetaDataFieldName("");
    setMetaDataFieldValue("");
  }

  const handleAddDefaultColumn = () => {

    if (defaultColumnsFieldName.isValid && defaultColumnsDataType.isValid) {
      var tableColumn = {};
      //tableColumn.recordType = masterKeyRecordType.value;
      tableColumn.fieldName = defaultColumnsFieldName.value;
      tableColumn.dataType = defaultColumnsDataType.value;
      // tableColumn.isRequired = isRequired;
      // tableColumn.isPrimaryKey = isPrimaryKey;
      setDefaultColumnsFieldName({
        value: "",
        isValid: false,
      });
      console.log('tableColumn', tableColumn);
      setDefaultColumns([...defaultColumns, tableColumn]);
    }
  }


  const createTable = () => {
    console.log('createTable', selectedMaster);


    var data = {
      projectId,
      dbName,
      masterKeys: selectedMaster,
      isIntermeditaryDataDatabase
    };

    if(isEdit){
      setIsLoading(true);
      ProjectDataService.createtable(data).then((response) => {
        setIsLoading(false);
        console.log('response', response);
        if(response.data.success){
          toast.success("Table Created!");
          navigate("/projects/" + projectId);
        } else {
          toast.error("Table Not Created!");
        }
      });
      // ProjectDataService.updatetable(projectId, data).then(() => {
      //   console.log('data', data);
      //   toast.success("Table Updated!");
      //   navigate("/projects/" + projectId);
      // });
    }
  }

  

  const closeModal = () => {
    setShowModal(!showModal);
    setMasterKeyName("");
    setMasterTableName("");
    setInsertOrder("");
    setMasterFieldKeys([]);
    setSelectedMaster({});
  }

  return (
    <Container fluid="md">
      <Row>
        <Col sm={5}><h1 className="mt-4 mb-2 pageTitle">{isEdit ? 'Edit' : isView ? 'View' : 'Create New'} Project</h1></Col>
        <Col sm={7}>
          <Stack direction="horizontal" gap={2}>
          <Button
            className="btn btn-light mt-4"
            theme="accent"
            onClick={() => navigate(`/projects`)}
          >
            <FcList /> View All
          </Button>

          {!isView && (
            <Button
              className="btn btn-primary mt-4"
              theme="accent"
              onClick={() => addMetaData()}
            >
              <FcPlus /> Add MetaData
            </Button>
          )}

          {!isView && (
            <Button
              className="btn btn-primary mt-4"
              theme="accent"
              onClick={() => addDefaultColumns()}
            >
              <FcPlus /> Add Default Column
            </Button>
          )}
          </Stack>
          
        </Col>
      </Row>
      <Row>
        <Col>&nbsp;</Col>
      </Row>
      <Row>
        <Col>
          <Form>
            <Row>
              <Col md="12" className="form-group">
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Project Name</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isEdit || isView) ? (
                      projectName
                    ) : (
                        <FormInputText
                        className="forminput"
                        placeholder="Project Name"
                        value={projectName}
                        setFunc={setProjectName}
                        showLabel={false}
                      />
                    )}
                  </Col>
                </Row> 

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Project Country</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      country
                    ) : (
                        <FormSelect
                          className="forminput"
                          placeholder="Select Country"
                          optionList={countryList}
                          value={country}
                          setFunc={setCountry}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> 

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Project Asset Code</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      assetCode
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="Asset Code"
                          value={assetCode}
                          setFunc={setAssetCode}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row>
                

                {/* <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="isDataApi">Data Send To API</label>
                    </Col>
                    <Col className="form-field" md="8">
                      <BootstrapSwitchButton
                        checked={isDataApi}
                        id="isDataApi"
                        onlabel="Yes"
                        offlabel="No"
                        setFunc={(e) => setIsDataApi(e.target.value)}
                      />
                    </Col>
                </Row> */}

                <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="isDataApi">Select Database</label>
                    </Col>
                    <Col className="form-field" md="8">
                      {/* {(isEdit || isView) ? (
                        databaseType === 'mysql' ? "MY SQL" : 'mssql' ? "MS SQL" : 'postgres' ? "POSTGRES SQL" : databaseType
                      ) : ( */}
                        <FormSelect
                          className="forminput"
                          placeholder="Select Database"
                          optionList={dataBaseTypes}
                          value={databaseType}
                          setFunc={setDatabaseType}
                          showLabel={false}
                        />
                      {/* )} */}
                    </Col>
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">
                      DB Configuration
                    </label>
                  </Col>
                  <Col className="form-field" md="8">
                    <Row>
                      <Col className="form-field" md="8">
                        {isView ? (
                          `DB HOST URL: ${dbHostURL}`
                        ) : (
                        <FormInputText
                          id="dbHostURL"
                          placeholder="DB Host"
                          value={dbHostURL}
                          setFunc={setDbHostURL}
                          showLabel={false}
                        />
                        )}
                      </Col>
                      <Col className="form-field" md="4">
                        {isView ? (
                          `DB PORT: ${dbPort}`
                        ) : (
                        <FormInputText
                          id="dbPort"
                          placeholder="DB PORT"
                          value={dbPort}
                          setFunc={setDbPort}
                          showLabel={false}
                        />
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="form-field" md="6">
                        {(isView) ? (
                          `DB USER NAME: ${dbUserName}`
                        ) : (
                          <FormInputText
                            id="dbUserName"
                            placeholder="DB User Name"
                            value={dbUserName}
                            setFunc={setDbUserName}
                            showLabel={false}
                          />
                        )}
                      </Col>
                      <Col className="form-field" md="6">
                        {(isView) ? (
                          `DB password: ***********`
                        ) : (
                          <FormInputText
                            id="dbPassword"
                            type="password"
                            placeholder="DB Password"
                            value={dbPassword}
                            setFunc={setDbPassword}
                            showLabel={false}
                          />
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="form-field" md="12">
                        {(isView) ? (
                          `DB Name: ${dbName}`
                        ) : (
                          <FormInputText
                            id="dbName"
                            placeholder="DB Name"
                            value={dbName}
                            setFunc={setDbName}
                            showLabel={false}
                          />
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="isIntermeditaryDataDatabase">has Intermeditary Database</label>
                  </Col>
                  <Col className="form-field" md="8">
                    <BootstrapSwitchButton
                      checked={isIntermeditaryDataDatabase}
                      id="isIntermeditaryDataDatabase"
                      onlabel="Yes"
                      offlabel="No"
                      onChange={(val) => setIsIntermeditaryDataDatabase(val)}
                    />
                  </Col>
                </Row>

                {isIntermeditaryDataDatabase && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="feFirstName">
                        Intermeditary DB Configuration
                      </label>
                    </Col>
                    <Col className="form-field" md="8">
                      <Row>
                      <Col className="form-field" md="12">
                          <FormSelect
                            className="forminput"
                            placeholder="Select Database"
                            optionList={dataBaseTypes}
                            value={indatabaseType}
                            setFunc={setInDatabaseType}
                            showLabel={false}
                          />
                      </Col>
                        <Col className="form-field" md="8">
                          {isView ? (
                            `DB HOST URL: ${indbHostURL}`
                          ) : (
                          <FormInputText
                            id="dbHostURL"
                            placeholder="DB Host"
                            value={indbHostURL}
                            setFunc={setInDbHostURL}
                            showLabel={false}
                          />
                          )}
                        </Col>
                        <Col className="form-field" md="4">
                          {isView ? (
                            `DB PORT: ${indbPort}`
                          ) : (
                          <FormInputText
                            id="dbPort"
                            placeholder="DB PORT"
                            value={indbPort}
                            setFunc={setInDbPort}
                            showLabel={false}
                          />
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col className="form-field" md="6">
                          {(isView) ? (
                            `DB USER NAME: ${indbUserName}`
                          ) : (
                            <FormInputText
                              id="dbUserName"
                              placeholder="DB User Name"
                              value={indbUserName}
                              setFunc={setInDbUserName}
                              showLabel={false}
                            />
                          )}
                        </Col>
                        <Col className="form-field" md="6">
                          {(isView) ? (
                            `DB password: ***********`
                          ) : (
                            <FormInputText
                              id="dbPassword"
                              type="password"
                              placeholder="DB Password"
                              value={indbPassword}
                              setFunc={setInDbPassword}
                              showLabel={false}
                            />
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col className="form-field" md="12">
                          {(isView) ? (
                            `DB Name: ${dbName}`
                          ) : (
                            <FormInputText
                              id="dbName"
                              placeholder="DB Name"
                              value={indbName}
                              setFunc={setInDbName}
                              showLabel={false}
                            />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">
                      File Location Configuration
                    </label>
                  </Col>
                  <Col className="form-field" md="8">
                    <Row>
                      <Col className="form-field" md="9">
                        {isView ? (
                          `server path: ${serverPath}`
                        ) : (
                        <FormInputText
                          id="serverPath"
                          placeholder="Server Path"
                          value={serverPath}
                          setFunc={setServerPath}
                          showLabel={false}
                        />
                        )}
                      </Col>
                      <Col className="form-field" md="3">
                        {(isView) ? (
                          `server port: ${serverPortNumber}`
                        ) : (
                          <FormInputText
                            id="serverPortNumber"
                            placeholder="Port"
                            type="number"
                            value={serverPortNumber}
                            setFunc={setServerPortNumber}
                            showLabel={false}
                          />
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="form-field" md="6">
                        {(isView) ? (
                          `server user name: ${serverUserName}`
                        ) : (
                          <FormInputText
                            id="serverUsername"
                            placeholder="Server User Name"
                            value={serverUserName}
                            setFunc={setServerUserName}
                            showLabel={false}
                          />
                        )}
                      </Col>
                      <Col className="form-field" md="6">
                        {(isView) ? (
                          `server password: ***********`
                        ) : (
                          <FormInputText
                            id="serverPassword"
                            type="password"
                            placeholder="Server Password"
                            value={serverPassword}
                            setFunc={setServerPassword}
                            showLabel={false}
                          />
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="form-field" md="12">
                        {(isView) ? (
                          `server folder path: ${serverFolderPath}`
                        ) : (
                          <FormInputText
                            id="folderPath"
                            placeholder="Folder Path"
                            value={serverFolderPath}
                            setFunc={setServerFolderPath}
                            showLabel={false}
                          />
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {defaultColumns && defaultColumns.length > 0 && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="">Default Columns</label>
                    </Col>
                    <Col className="form-field" md="8">
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        {/* <Col className="form-label" md="4">
                          Record Type
                        </Col> */}
                        <Col className="form-label" md="9">
                          Default Columns Field Name
                        </Col>
                        <Col className="form-label" md="3">
                          Data Type
                        </Col>
                        {/* <Col className="form-label" md="2">
                          Required
                        </Col>
                        <Col className="form-label" md="2">
                          Primary
                        </Col> */}
                      </Row>
                      {defaultColumns.map((mtItem, mtIndex) => {
                          return (
                            <Row className="form-group-row border-bottom-button ml-2 mr-2" key={`defaultColumns-${mtIndex} + 1`}>
                              {/* <Col className="form-field" md="4">
                                {mtItem.recordType}
                              </Col> */}
                              <Col className="form-field" md="9">
                                {mtItem.fieldName}
                              </Col>
                              <Col className="form-field" md="3">
                                {mtItem.dataType}
                              </Col>
                              {/* <Col className="form-field" md="2">
                                {mtItem.isRequired === true ? "Yes" : "No"}
                              </Col>
                              <Col className="form-field" md="2">
                                {mtItem.isPrimaryKey === true ? "Yes" : "No"}
                              </Col> */}
                            </Row>
                          );
                        })}
                    </Col>
                  </Row>
                      
                )}

                {showDefaultColumns && !isView && (
                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                    <Col className="form-field" md="12">
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                          Default Column Name:
                        </Col>
                        <Col className="form-field" md="6">
                          Default Column Data Type:
                        </Col>
                        <Col className="form-field" md="2">
                        </Col>
                      </Row>
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                          {/* <label htmlFor="defaultColumnFieldValue">Column Name</label> */}
                            <FormInputText
                              id="defaultColumnFieldName"
                              placeholder="Default Column Name"
                              value={defaultColumnsFieldName.value}
                              setFunc={onChangeDefaultColumnsFieldName}
                              showLabel={false}
                            />
                        </Col>
                        <Col className="form-field" md="6">
                          {/* <label htmlFor="defaultColumnFieldValue">Data Type</label> */}
                          <FormSelect
                            id="defaultColumnFieldValue"
                            className={
                              masterKeyFieldSubmit
                                ? masterKeyDataType.isValid
                                  ? ""
                                  : "field-error"
                                : ""
                            }
                            optionList={masterKeyDataTypes}
                            value={defaultColumnsDataType.value}
                            setFunc={onChangeDefaultColumnsDataType}
                            showLabel={false}
                            label="Data Type"
                          >
                          </FormSelect>
                        </Col>
                        <Col className="form-field" md="2">
                          <Button variant="primary" onClick={() => handleAddDefaultColumn()}>
                              {/* <FcPlus size="16" />  */}
                              Add 
                            </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}


                {metadata && metadata.map((mdItem, mdIndex) => {
                    return (
                      <Row className="form-group-row border-bottom-button ml-2 mr-2"  key={`metadata-${mdIndex} + 1`}>
                        <Col className="form-label" md="4">
                          {mdItem.metadataName}
                        </Col>
                        <Col className="form-field" md="6">
                          {(isView) ? (
                            `${mdItem.metadataValue}`
                          ) : (
                            <FormInputText
                                id={`metadataValue-${mdIndex}`}
                                placeholder="Metadata Value"
                                value={mdItem.metadataValue}
                                name={mdItem.metadataName}
                                setFunc={onChangeMMetadataFieldValue}
                                showLabel={false}
                              />
                          )}
                          </Col>
                        <Col className="form-field" md="2">
                        </Col>
                      </Row>
                    );
                })}

                {showMetadata && !isView && (
                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                    <Col className="form-field" md="12">
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                          Meta Data Name:
                        </Col>
                        <Col className="form-field" md="6">
                          Meta Data Value:
                        </Col>
                        <Col className="form-field" md="2">
                        </Col>
                      </Row>
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                            <FormInputText
                              id="metadataName"
                              placeholder="Metadata Name"
                              value={metaDataFieldName}
                              setFunc={setMetaDataFieldName}
                              showLabel={false}
                            />
                        </Col>
                        <Col className="form-field" md="6">
                            <FormInputText
                              id="metadataValue"
                              placeholder="Metadata Value"
                              value={metaDataFieldValue}
                              setFunc={setMetaDataFieldValue}
                              showLabel={false}
                            />
                        </Col>
                        <Col className="form-field" md="2">
                          <Button variant="primary" onClick={() => handleAddMetaData()}>
                              {/* <FcPlus size="16" />  */}
                              Add 
                            </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}

                

                {/* { masterKeys &&
                    masterKeys.map(
                      (masterItem, masterIndex) => {
                        return (
                          <Row className="form-group-row" key={masterIndex + 1}>
                            <Col className="form-label" md="4">
                              <label htmlFor="feFirstName">
                                    {masterItem.masterKeyName}
                              </label>
                            </Col>
                            <Col className="form-field" md="8">
                              <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                <Col className="form-label" md="7">
                                  Field Name
                                </Col>
                                <Col className="form-label" md="5">
                                  Data Type
                                </Col>
                                {/* <Col className="form-label" md="2">
                                  Required
                                </Col>
                                <Col className="form-label" md="2">
                                  Primary
                                </Col> 
                              </Row>
                              {masterItem.masterKeyFields &&
                              masterItem.masterKeyFields.map(
                                (masterFieldItem, masterFieldIndex) => {
                                  return (
                                    <Row
                                      className="form-group-row border-bottom-button ml-2 mr-2"
                                      key={masterFieldIndex + 1}
                                    >
                                      <Col className="form-field" md="7">
                                        {masterFieldItem.fieldName}
                                      </Col>
                                      <Col className="form-field" md="5">
                                        {masterFieldItem.dataType}
                                      </Col>
                                      {/* <Col className="form-field" md="2">
                                        {masterFieldItem.isRequired === true ? "Yes" : "No"}
                                      </Col>
                                      <Col className="form-field" md="2">
                                        {masterFieldItem.isPrimaryKey === true ? "Yes" : "No"}
                                      </Col> 
                                    </Row>
                                  );
                                }
                              )}
                              {masterItem.hasAssociatedTable && (
                                <Row className="form-group-row mt-3">
                                  <Col className="form-label" md="3">
                                    <label htmlFor="">Has Associated Table ?</label>
                                  </Col>
                                  <Col className="form-field flx-items-center" md="9">
                                    {masterItem.hasAssociatedTable ? "YES" : "NO"}
                                  </Col>
                                </Row>
                              )}
                              {masterItem.hasAssociatedTable ? (
                                <>
                                  <Row className="form-group-row customized-01">
                                    <Col className="form-label" md="3">
                                      <label htmlFor="">Associated Table Name</label>
                                    </Col>
                                    <Col className="form-field flx-items-center" md="9">
                                      {masterItem.associatedTableName}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                    <Col className="form-label" md="5">
                                      Table Field Name
                                    </Col>
                                    <Col className="form-label" md="3">
                                      Data Type
                                    </Col>
                                    <Col className="form-label" md="2">
                                      Required
                                    </Col>
                                    <Col className="form-label" md="2">
                                      Primary
                                    </Col>
                                  </Row>
                                  {masterItem.associatedKeyFields &&
                                    masterItem.associatedKeyFields.map((mtItem, mtIndex) => {
                                      return (
                                        <Row className="form-group-row border-bottom-button ml-2 mr-2" key={mtIndex + 1}>
                                          <Col className="form-field" md="5">
                                            {mtItem.fieldName}
                                          </Col>
                                          <Col className="form-field" md="3">
                                            {mtItem.dataType}
                                          </Col>
                                          {/* <Col className="form-field" md="2">
                                            {mtItem.isRequired === true ? "Yes" : "No"}
                                          </Col>
                                          <Col className="form-field" md="2">
                                            {mtItem.isPrimaryKey === true ? "Yes" : "No"}
                                          </Col> 
                                        </Row>
                                      );
                                    })}
                                </>
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                      );
                    }
                  )} */}

                
                  <Row className="form-group-row">
                    <Col className="form-field font-bold" md="4">
                      <label htmlFor="">Master Key Files</label>
                    </Col>
                    {(isEdit || isCreate) && (
                      <Col className="form-field mb-3" md="8">
                        <Button className="ml-3" variant="primary" onClick={() => setShowModal(!showModal)}>
                          <FcPlus /> Add Master Key File
                        </Button>
                      </Col>
                    )}
                  </Row>
                

                {/* <Row className="form-group-row">
                  <Col className="form-label-12 font-bold" md="12">
                    <label htmlFor="">File Type</label>
                  </Col>
                </Row> */}

                <Row className="form-group-row accordian-row">
                  <Accordion>
                    {masterFiles &&
                      masterFiles.map((item, index) => {
                        return (
                          <Accordion.Item eventKey={index + 1} datakey={index + 1} key={`masterFiles-${index} + 1`}>
                            {/* <Accordion.Header>{item.masterKeyName}</Accordion.Header> */}
                            <Accordion.Header>
                              { (isEdit || isCreate) && (
                                <>
                                  <a variant="primary" className="ml-2 btn btn-light" onClick={() => handleEditFieldForm(item._id)}><TiEdit size="14"/> Edit</a>
                                  &nbsp;&nbsp;&nbsp;&nbsp;
                                </>
                              )}
                              <div className="ml-3">File {index + 1} - {item.masterKeyName}</div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <Row className="form-group-row">
                                <Col className="form-label" md="4">
                                  <label htmlFor="">Master Key Name</label>
                                </Col>
                                <Col className="form-field flx-items-center" md="8">
                                  {item.masterKeyName}
                                </Col>
                              </Row>
                              <Row className="form-group-row">
                                <Col className="form-label" md="4">
                                  <label htmlFor="">Master Table Name</label>
                                </Col>
                                <Col className="form-field flx-items-center" md="8">
                                  {item.masterTableName}
                                </Col>
                              </Row>
                              <Row className="form-group-row">
                                <Col className="form-label" md="4">
                                  <label htmlFor="">Is Master Table</label>
                                </Col>
                                <Col className="form-field flx-items-center" md="8">
                                  {item.isMaster === true ? 'YES' : 'NO'}
                                </Col>
                              </Row>

                              <Row className="form-group-row">
                                <Col className="form-label" md="4">
                                  <label htmlFor="">Master Insert Order</label>
                                </Col>
                                <Col className="form-field flx-items-center" md="8">
                                  {item.insertOrder}
                                </Col>
                              </Row>

                              
                              <Row className="form-group-row">
                                <Col className="form-label" md="4">
                                  <label htmlFor="">Master Key Fields</label>
                                </Col>
                                <Col className="form-field" md="8">
                                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                    {/* <Col className="form-label" md="4">
                                      Record Type
                                    </Col> */}
                                    <Col className="form-label" md="9">
                                      Master KEY Field Name
                                    </Col>
                                    <Col className="form-label" md="3">
                                      Data Type
                                    </Col>
                                    {/* <Col className="form-label" md="2">
                                      Required
                                    </Col>
                                    <Col className="form-label" md="2">
                                      Primary
                                    </Col> */}
                                  </Row>
                                  {item.masterKeyFields &&
                                    item.masterKeyFields.map((mtItem, mtIndex) => {
                                      return (
                                        <Row className="form-group-row border-bottom-button ml-2 mr-2" key={`masterKeyFields-${mtIndex} + 1`}>
                                          {/* <Col className="form-field" md="4">
                                            {mtItem.recordType}
                                          </Col> */}
                                          <Col className="form-field" md="9">
                                            {mtItem.fieldName}
                                          </Col>
                                          <Col className="form-field" md="3">
                                            {mtItem.dataType}
                                          </Col>
                                          {/* <Col className="form-field" md="2">
                                            {mtItem.isRequired === true ? "Yes" : "No"}
                                          </Col>
                                          <Col className="form-field" md="2">
                                            {mtItem.isPrimaryKey === true ? "Yes" : "No"}
                                          </Col> */}
                                        </Row>
                                      );
                                    })}
                                </Col>
                              </Row>

                              <Row className="form-group-row">
                                <Col className="form-label" md="4">
                                  <label htmlFor="">Additional Default Metadata Fields</label>
                                </Col>
                                <Col className="form-field" md="8">
                                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                    {/* <Col className="form-label" md="4">
                                      Record Type
                                    </Col> */}
                                    <Col className="form-label" md="9">
                                      Metadata Field Name
                                    </Col>
                                    <Col className="form-label" md="3">
                                      Data Type
                                    </Col>
                                    {/* <Col className="form-label" md="2">
                                      Required
                                    </Col>
                                    <Col className="form-label" md="2">
                                      Primary
                                    </Col> */}
                                  </Row>
                                  {item.masterKeyMetaDataFields &&
                                    item.masterKeyMetaDataFields.map((mtItem, mtIndex) => {
                                      return (
                                        <Row className="form-group-row border-bottom-button ml-2 mr-2" key={`masterKeyFields-${mtIndex} + 1`}>
                                          {/* <Col className="form-field" md="4">
                                            {mtItem.recordType}
                                          </Col> */}
                                          <Col className="form-field" md="9">
                                            {mtItem.fieldName}
                                          </Col>
                                          <Col className="form-field" md="3">
                                            {mtItem.dataType}
                                          </Col>
                                          {/* <Col className="form-field" md="2">
                                            {mtItem.isRequired === true ? "Yes" : "No"}
                                          </Col>
                                          <Col className="form-field" md="2">
                                            {mtItem.isPrimaryKey === true ? "Yes" : "No"}
                                          </Col> */}
                                        </Row>
                                      );
                                    })}
                                </Col>
                              </Row>


                              {/* { hasAssociatedTable && (
                                <Row className="form-group-row">
                                  <Col className="form-label" md="4">
                                    <label htmlFor="">Associated Table</label>
                                  </Col>
                                  <Col className="form-field" md="8">
                                    <Row className="form-group-row">
                                      <Col className="form-label" md="3">
                                        <label htmlFor="">Has Associated Table ?</label>
                                      </Col>
                                      <Col className="form-field flx-items-center" md="9">
                                        {item.hasAssociatedTable ? "YES" : "NO"}
                                      </Col>
                                    </Row>
                                    {hasAssociatedTable ? (
                                      <>
                                        <Row className="form-group-row customized-01">
                                          <Col className="form-label" md="3">
                                            <label htmlFor="">Associated Table Name</label>
                                          </Col>
                                          <Col className="form-field flx-items-center" md="9">
                                            {item.associatedTableName}
                                          </Col>
                                        </Row>
                                        <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                          <Col className="form-label" md="5">
                                            Table Field Name
                                          </Col>
                                          <Col className="form-label" md="3">
                                            Data Type
                                          </Col>
                                          <Col className="form-label" md="2">
                                            Required
                                          </Col>
                                          <Col className="form-label" md="2">
                                            Primary
                                          </Col>
                                        </Row>
                                        {item.associatedKeyFields &&
                                          item.associatedKeyFields.map((mtItem, mtIndex) => {
                                            return (
                                              <Row
                                                className="form-group-row border-bottom-button ml-2 mr-2"
                                                key={mtIndex + 1}
                                              >
                                                <Col className="form-field" md="5">
                                                  {mtItem.fieldName}
                                                </Col>
                                                <Col className="form-field" md="3">
                                                  {mtItem.dataType}
                                                </Col>
                                                <Col className="form-field" md="2">
                                                  {mtItem.isRequired === true ? "Yes" : "No"}
                                                </Col>
                                                <Col className="form-field" md="2">
                                                  {mtItem.isPrimaryKey === true ? "Yes" : "No"}
                                                </Col>
                                              </Row>
                                            );
                                          })}
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </Col>
                                </Row>
                              )} */}
                              
                            </Accordion.Body>
                          </Accordion.Item>
                        );
                      })}
                  </Accordion>
                </Row>
                
                {(isEdit || isCreate) && (
                  <Row className="form-group-row">
                    <Col className="form-button" md="12">
                        <Button
                          className="btn btn-primary"
                          theme="accent"
                          onClick={() => createEditProject()}
                        >
                          <FcPlus /> { isEdit ? 'Update' : 'Create' } Project
                        </Button>
                    </Col>
                  </Row>
                )}

                {(isView) && (
                  <Row className="form-group-row">
                    <Col className="form-button" md="12">
                        <Button
                          className="btn btn-primary"
                          theme="accent"
                          onClick={() => navigate(`/projects/edit/${projectId}`)} 
                        >
                          <TiEdit /> Edit Project
                        </Button>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
            <Row className="form-group-row">
              <Col className="form-field font-bold" md="12">
                &nbsp;
              </Col>
            </Row>
            {/* <Row className="form-group-row">
              <Col className="form-field font-bold" md="12">
                &nbsp;
              </Col>
            </Row> */}
          </Form>
        </Col>
      </Row>

      <Modal show={showModal} size="lg" className="filePopup" onHide={closeModal}>
          <Modal.Header>
                <Modal.Title>Add Master Key File</Modal.Title>
                {projectId && (
                  <Button className="ml-3" variant="primary" onClick={(masterFieldKeys) => createTable()}>
                    <FcPlus /> Create Table
                  </Button>
                )}
                <div className="closeBtn" onClick={closeModal} aria-label="Close">
                  <TiDeleteOutline size={25} />
                </div>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="form-group-row">
                <Col className="form-label" md="3">
                  <label htmlFor="masterKeyName"> Master Key Name</label>
                </Col>
                <Col className="form-field" md="9">
                  <FormInputText
                    id="masterKeyName"
                    placeholder="Master Key Name"
                    value={masterKeyName}
                    setFunc={setMasterKeyName}
                    showLabel={false}
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="3">
                  <label htmlFor="masterTableName"> Master Table Name</label>
                </Col>
                <Col className="form-field" md="9">
                  <FormInputText
                    id="masterTableName"
                    placeholder="Master Table Name"
                    value={masterTableName}
                    setFunc={setMasterTableName}
                    showLabel={false}
                  />
                </Col>
              </Row>

              <Row className="form-group-row">
                <Col className="form-label" md="3">
                  <label htmlFor="isMaster"> Is Master</label>
                </Col>
                <Col className="form-field" md="9">
                  <BootstrapSwitchButton
                    checked={isMaster}
                    id="isMaster"
                    onlabel="Yes"
                    offlabel="No"
                    onChange={(val) => setIsMaster(val)}
                  />
                </Col>
              </Row>

              <Row className="form-group-row">
                <Col className="form-label" md="3">
                  <label htmlFor="isMaster">Master Insert Order</label>
                </Col>
                <Col className="form-field" md="9">
                  <FormInputText
                    id="insertOrder"
                    placeholder="Master Insert Order"
                    value={insertOrder}
                    setFunc={setInsertOrder}
                    showLabel={false}
                  />
                </Col>
              </Row>

              

              
              

              <Row className="form-group-row border-bottom-button">
                <Col className="form-label" md="3">
                  <label htmlFor="masterTransactionFields"> Master Key Fields</label>
                </Col>
                <Col className="form-field" md="9">
                  <Row>
                    <Col md="10">
                      <Row>
                        {/* <Col className="form-field" md="4">
                          <label htmlFor="masterKeyRecordType">Record Type</label>
                          <FormSelect
                            id="masterKeyRecordType"
                            className={
                              masterKeyFieldSubmit
                                ? masterKeyRecordType.isValid
                                  ? ""
                                  : "field-error"
                                : ""
                            }
                            optionList={masterKeyRecordTypesArray}
                            value={masterKeyRecordType.value}
                            setFunc={onChangeMasterKeyRecordType}
                            showLabel={false}
                            label="Record Type"
                          >
                          </FormSelect>
                        </Col> */}
                        <Col className="form-field" md="8">
                          <label htmlFor="masterKeyFieldName">Master Key Field Name</label>
                          <FormInputText
                            id="masterKeyFieldName"
                            placeholder="Master Key Field Name"
                            className={
                              masterKeyFieldSubmit
                                ? masterKeyFieldName.isValid
                                  ? ""
                                  : "field-error"
                                : ""
                            }
                            value={(masterKeyFieldName && masterKeyFieldName.value) || ''}
                            setFunc={onChangeMasterKeyFieldName}
                            showLabel={false}
                          />
                        </Col>
                        <Col className="form-field" md="3">
                          <label htmlFor="masterKeyDataType">Data Type</label>
                          <FormSelect
                            id="masterKeyDataType"
                            className={
                              masterKeyFieldSubmit
                                ? masterKeyDataType.isValid
                                  ? ""
                                  : "field-error"
                                : ""
                            }
                            optionList={masterKeyDataTypes}
                            value={masterKeyDataType.value}
                            setFunc={onChangeMasterKeyDataType}
                            showLabel={false}
                            label="Data Type"
                          >
                          </FormSelect>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="2">
                      <Row>
                        {/* <Col className="form-field" md="4">
                          <label htmlFor="isRequired">Required</label>
                          <BootstrapSwitchButton
                            checked={isRequired}
                            id="isRequired"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => onSwitchChanged("isRequired", val)}
                          />
                        </Col>
                        <Col className="form-field" md="4">
                          <label htmlFor="isPrimaryKey">Primary</label>
                          <BootstrapSwitchButton
                            checked={isPrimaryKey}
                            id="isPrimaryKey"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => onSwitchChanged("isPrimaryKey", val)}
                          />
                        </Col> */}
                        <Col className="form-field flx-items-end mt-4" md="12">
                          <Button variant="primary" onClick={() => handleAddMasterFieldKeys()}>
                            {/* <FcPlus size="16" />  */}
                            Add 
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row className="form-group-row ml-1 mr-1 border-bottom-button">
                    {/* <Col className="form-label" md="3">
                      <label htmlFor="filedName">Field Type</label>
                    </Col> */}
                    <Col className="form-label" md="7">
                      <label htmlFor="filedName">Key Field Name</label>
                    </Col>
                    <Col className="form-label" md="3">
                      <label htmlFor="">Data Type</label>
                    </Col>
                    {/* <Col className="form-label" md="2">
                      <label htmlFor="">Required</label>
                    </Col>
                    <Col className="form-label" md="2">
                      <label htmlFor="">Primary</label>
                    </Col> */}
                    <Col className="form-label" md="2">
                      <label htmlFor="">Action</label>
                    </Col>
                  </Row>
                  {masterFieldKeys &&
                    masterFieldKeys.map((item, index) => {
                      return (
                        <Row className="form-group-row ml-1 mr-1 border-bottom-button" key={`masterFieldKeys-${index} + 1`}>
                          {/* <Col className="form-field" md="3">
                            {item.recordType}
                          </Col> */}
                          <Col className="form-field" md="7">
                            {item.fieldName}
                          </Col>
                          <Col className="form-field" md="3">
                            {item.dataType}
                          </Col>
                          {/* <Col className="form-field" md="2">
                            {item.isRequired === true ? "Yes" : "No"}
                          </Col>
                          <Col className="form-field" md="2">
                            {item.isPrimaryKey === true ? "Yes" : "No"}
                          </Col> */}
                          <Col className="form-label" md="2">
                            <div
                              className="closeBtn"
                              onClick={() => deleteMasterKeyFieldName(item.fieldName)}
                              aria-label="Close"
                            >
                              <TiDeleteOutline size={25} />
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                </Col>
              </Row>

              <Row className="form-group-row border-bottom-button">
                <Col className="form-label" md="3">
                  <label htmlFor="masterTransactionFields"> Additional default Metadata Fields</label>
                </Col>
                <Col className="form-field" md="9">
                  <Row>
                    <Col md="10">
                      <Row>
                        {/* <Col className="form-field" md="4">
                          <label htmlFor="masterKeyRecordType">Record Type</label>
                          <FormSelect
                            id="masterKeyRecordType"
                            className={
                              masterKeyFieldSubmit
                                ? masterKeyRecordType.isValid
                                  ? ""
                                  : "field-error"
                                : ""
                            }
                            optionList={masterKeyRecordTypesArray}
                            value={masterKeyRecordType.value}
                            setFunc={onChangeMasterKeyRecordType}
                            showLabel={false}
                            label="Record Type"
                          >
                          </FormSelect>
                        </Col> */}
                        <Col className="form-field" md="8">
                          <label htmlFor="MetadataFieldName">Metadata Field Name</label>
                          <FormInputText
                            id="MetadataFieldName"
                            placeholder="Metadata Field Name"
                            className={
                              masterKeyFieldSubmit
                                ? masterKeyFieldName.isValid
                                  ? ""
                                  : "field-error"
                                : ""
                            }
                            value={(masterKeyMetaDataFieldName && masterKeyMetaDataFieldName.value) || ''}
                            setFunc={onChangeMasterKeyMetadataFieldName}
                            showLabel={false}
                          />
                        </Col>
                        <Col className="form-field" md="3">
                          <label htmlFor="masterKeyDataType">Data Type</label>
                          <FormSelect
                            id="masterKeyDataType"
                            className={
                              masterKeyFieldSubmit
                                ? masterKeyMetaDataType.isValid
                                  ? ""
                                  : "field-error"
                                : ""
                            }
                            optionList={masterKeyDataTypes}
                            value={masterKeyMetaDataType.value}
                            setFunc={onChangeMasterKeyMetaDataType}
                            showLabel={false}
                            label="Data Type"
                          >
                          </FormSelect>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="2">
                      <Row>
                        <Col className="form-field flx-items-end mt-4" md="12">
                          <Button variant="primary" onClick={() => handleAddMasterMetaDataFieldKeys()}>
                            {/* <FcPlus size="16" />  */}
                            Add 
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row className="form-group-row ml-1 mr-1 border-bottom-button">
                    <Col className="form-label" md="7">
                      <label htmlFor="filedName">Key Field Name</label>
                    </Col>
                    <Col className="form-label" md="3">
                      <label htmlFor="">Data Type</label>
                    </Col>
                    <Col className="form-label" md="2">
                      <label htmlFor="">Action</label>
                    </Col>
                  </Row>
                  {masterMetaDataFieldKeys &&
                    masterMetaDataFieldKeys.map((item, index) => {
                      return (
                        <Row className="form-group-row ml-1 mr-1 border-bottom-button" key={`masterMetaDataFieldKeys-${index} + 1`}>
                          <Col className="form-field" md="7">
                            {item.fieldName}
                          </Col>
                          <Col className="form-field" md="3">
                            {item.dataType}
                          </Col>
                          <Col className="form-label" md="2">
                            <div
                              className="closeBtn"
                              onClick={() => deleteMasterMetaDataKeyFieldName(item.fieldName)}
                              aria-label="Close"
                            >
                              <TiDeleteOutline size={25} />
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                </Col>
              </Row>

              {/* <Row className="form-group-row border-bottom-button">
                <Col className="form-label" md="3">
                  <label htmlFor="masterTransactionFields"> Associated Table</label>
                </Col>
                <Col className="form-field" md="9">
                  <Row className="mb-3">
                    <Col md="12">
                      <label htmlFor="hasAssociatedTable" className="mr-4">
                        Has Associated Table ?
                      </label>
                      <BootstrapSwitchButton
                        checked={hasAssociatedTable}
                        id="hasAssociatedTable"
                        onlabel="Yes"
                        offlabel="No"
                        onChange={(val) => onSwitchChanged("hasAssociatedTable", val)}
                      />
                    </Col>
                  </Row>

                  {hasAssociatedTable ? (
                    <>
                      <Row className="mb-3">
                        <Col md="12">
                          <label htmlFor="associatedTableName">Associated Table Name</label>
                          <FormInput
                            id="associatedTableName"
                            placeholder="Associated Table Name"
                            value={associatedTableName}
                            onChange={onFieldValueChange}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="7">
                          <Row>
                            <Col className="form-field" md="7">
                              <label htmlFor="asscKeyFieldName">Associated Field Name</label>
                              <FormInput
                                id="asscKeyFieldName"
                                placeholder="Associated Field Name"
                                value={asscKeyFieldName.value}
                                onChange={onChangeAsscKeyFieldName}
                                className={
                                  asscKeyFieldSubmit
                                    ? asscKeyFieldName.isValid
                                      ? ""
                                      : "field-error"
                                    : ""
                                }
                              />
                            </Col>
                            <Col className="form-field" md="5">
                              <label htmlFor="asscKeyDataType">Data Type</label>
                              <FormSelect
                                id="asscKeyDataType"
                                onChange={onChangeAsscKeyDataType}
                                className={
                                  asscKeyFieldSubmit
                                    ? asscKeyDataType.isValid
                                      ? ""
                                      : "field-error"
                                    : ""
                                }
                              >
                                <option value="">Select Data Type</option>
                                <option value="Number">Number</option>
                                <option value="String">String</option>
                                <option value="Date">Date</option>
                              </FormSelect>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="5">
                          <Row>
                            <Col className="form-field" md="4">
                              <label htmlFor="isAsscRequired">Required</label>
                              <BootstrapSwitchButton
                                checked={isAsscRequired}
                                id="isAsscRequired"
                                onlabel="Yes"
                                offlabel="No"
                                onChange={(val) => onSwitchChanged("isAsscRequired", val)}
                              />
                            </Col>
                            <Col className="form-field" md="4">
                              <label htmlFor="isAsscPrimaryKey">Primary</label>
                              <BootstrapSwitchButton
                                checked={isAsscPrimaryKey}
                                id="isAsscPrimaryKey"
                                onlabel="Yes"
                                offlabel="No"
                                onChange={(val) => onSwitchChanged("isAsscPrimaryKey", val)}
                              />
                            </Col>
                            <Col className="form-field flx-items-end" md="4">
                              <Button variant="primary" onClick={handleAddAsscFieldKeys}>
                                Add {/*<FcPlus size="16" />
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row className="form-group-row ml-1 mr-1 border-bottom-button">
                        <Col className="form-label" md="5">
                          <label htmlFor="filedName">Associated Field Name</label>
                        </Col>
                        <Col className="form-label" md="2">
                          <label htmlFor="">Data Type</label>
                        </Col>
                        <Col className="form-label" md="2">
                          <label htmlFor="">Required</label>
                        </Col>
                        <Col className="form-label" md="2">
                          <label htmlFor="">Primary</label>
                        </Col>
                        <Col className="form-label" md="1">
                          <label htmlFor="">Action</label>
                        </Col>
                      </Row>
                      {asscFieldKeys &&
                        asscFieldKeys.map((item, index) => {
                          return (
                            <Row className="form-group-row ml-1 mr-1 border-bottom-button" key={index + 1}>
                              <Col className="form-field" md="5">
                                {item.fieldName}
                              </Col>
                              <Col className="form-field" md="2">
                                {item.dataType}
                              </Col>
                              <Col className="form-field" md="2">
                                {item.isRequired === true ? "Yes" : "No"}
                              </Col>
                              <Col className="form-field" md="2">
                                {item.isPrimaryKey === true ? "Yes" : "No"}
                              </Col>
                              <Col className="form-label" md="1">
                                <div
                                  className="closeBtn"
                                  onClick={deleteAsscKeyFieldName.bind(this, item.fieldName)}
                                  aria-label="Close"
                                >
                                  <TiDeleteOutline />
                                </div>
                              </Col>
                            </Row>
                          );
                        })}
                    </>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row> */}

              <Row>
                <Col className="md-3">
                  <Button variant="primary" className="mt-3" onClick={createMasterFile}>
                    <FcPlus /> Save File
                  </Button>
                </Col>
                
              </Row>
            </Form>
          </Modal.Body>
        </Modal>

    </Container>
  );
}

export default ProjectCreate;
